"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadonlyPropertySelector = ReadonlyPropertySelector;
const React = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const property_1 = require("@genesys/property");
const ProductProperties = __importStar(require("@genesys/shared/lib/product-properties"));
const AuthorizationTools = __importStar(require("@genesys/shared/lib/authorization"));
const AmountFormatSelector = __importStar(require("../amount-format-selector"));
const Contexts = __importStar(require("../contexts"));
const UserProfile = __importStar(require("../user-profile"));
const TableCell = styled_components_1.default.td `
  ${props => props.hasErrorMessage && `color: red;`};
`;
function ReadonlyPropertySelector({ conversionParameters, filterPrettyPrint, includeCodes, onPropertyFormatChanged, onPropertyFormatCleared, onPropertyFormatSelectorToggled, isQuantitySelectorActive, onQuantityChange, propertyName, fieldGroup, fieldName, selectedProperties, translatePropertyValue, validationFilter, valueItems }) {
    const propertyValue = property_1.PropertyValueSet.get(propertyName, selectedProperties);
    if (propertyValue === undefined) {
        return React.createElement("td", null, "\u00A0");
    }
    switch (propertyValue.type) {
        case "text": {
            return React.createElement("td", null, property_1.PropertyValue.getText(propertyValue));
        }
        case "integer": {
            const value = property_1.PropertyValue.getInteger(propertyValue);
            const valueItem = valueItems.find(vi => property_1.PropertyValue.equals(vi.value, propertyValue));
            const validationMessage = getValidationMessage(selectedProperties, (valueItem && valueItem.property_filter) || property_1.PropertyFilter.Empty, filterPrettyPrint) || undefined;
            return (React.createElement(TableCell, { hasErrorMessage: validationMessage !== undefined, title: validationMessage },
                translatePropertyValue(propertyName, value),
                " ",
                includeCodes && `(${value})`));
        }
        default: {
            const amount = property_1.PropertyValue.getAmount(propertyValue);
            return (React.createElement(UserProfile.UserProfile, null, user => (React.createElement(Contexts.propertiesSelectorContext.Consumer, null, ({ getAmountFormat }) => {
                const title = AuthorizationTools.checkPermission(user.applicationClaims, AuthorizationTools.genesysUserClaims.developer)
                    ? "GroupName: " + fieldGroup + "\nFieldName: " + fieldName
                    : undefined;
                const amountFormat = getAmountFormat(fieldGroup, fieldName, amount);
                const validationMessage = getValidationMessage(selectedProperties, validationFilter, filterPrettyPrint) || undefined;
                return (React.createElement(TableCell, { hasErrorMessage: validationMessage !== undefined, title: validationMessage },
                    ProductProperties.getValue(propertyValue, amountFormat, conversionParameters),
                    " ",
                    React.createElement("span", { title: title },
                        React.createElement(AmountFormatSelector.FormatSelectorRenderer, { AmountFormatSelector: AmountFormatSelector.AmountFormatSelectorWithPadding, conversionParameters: conversionParameters, onFormatChanged: (unit, decimalCount) => {
                                onPropertyFormatChanged(fieldName, unit, decimalCount);
                            }, onFormatCleared: () => {
                                onPropertyFormatCleared(fieldName);
                            }, onFormatSelectorActiveChanged: (active) => {
                                onPropertyFormatSelectorToggled(propertyName, active);
                            }, onQuantityChange: onQuantityChange, isQuantitySelectorActive: isQuantitySelectorActive, propertyType: propertyValue.type, selectedDecimalCount: amountFormat.decimalCount, selectedUnit: amountFormat.unit, userSelected: amountFormat.userDefined }))));
            }))));
        }
    }
}
function getValidationMessage(propertyValueSet, validationFilter, filterPrettyPrint) {
    if (property_1.PropertyFilter.isValid(propertyValueSet, validationFilter)) {
        return "";
    }
    else {
        return filterPrettyPrint(validationFilter);
    }
}
//# sourceMappingURL=readonly-property-selector.js.map